export const ROLE_LABEL = { owner: "Owner", admin: "Admin", editor: "Editor", viewer: "Viewer" };
export const isReviewer = (w) => w?.my_role === "owner" || w?.my_role === "admin";
export const isActive = (w) => w?.my_role === "owner" || w?.owner_pro;
export const canCreate = (w, cat) => isActive(w) && (isReviewer(w) || (w?.my_role === "editor" && (w.my_scope?.all || w.my_scope?.categories?.includes(cat))));
export const canEdit = (w, p) => canCreate(w, p.category) || (isActive(w) && w?.my_role === "editor" && w.my_scope?.page_ids?.includes(p.id));
export const canCreateAny = (w, cats) => cats.some((c) => canCreate(w, c));
export const scopeLabel = (scope, pages = []) => {
  if (!scope || scope.all) return "Whole wiki";
  const parts = [...(scope.categories || []), ...(scope.page_ids || []).map((id) => pages.find((p) => p.id === id)?.title || "entry")];
  return parts.length ? parts.join(", ") : "Nothing yet";
};
export const ago = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
